import {contracts} from './contracts.js';

const contractMethods = {
    USERS: {
        setName: contracts.USERS.methods.setName,
        setProfileHash: contracts.USERS.methods.setProfileHash,
    },
    TOKENIZED_SEQUENCES: {
        editSequence: contracts.TOKENIZED_SEQUENCES.methods.editSequence,
        buyTokens: contracts.TOKENIZED_SEQUENCES.methods.buyTokens,
    },
    GUILD_SEQUENCES: {
        editSequence: contracts.GUILD_SEQUENCES.methods.editSequence,
    },
    GUILD_PRESETS: {
        newPreset: contracts.GUILD_PRESETS.methods.newPreset,
        tagPreset: contracts.GUILD_PRESETS.methods.tagPreset,
    },
    GUILDS: {
        newGuild: contracts.GUILDS.methods.newGuild,
        requestToAddMember: contracts.GUILDS.methods.requestToAddMember,
        leaveGuild: contracts.GUILDS.methods.leaveGuild,
        acceptRequestToAddToGuild: contracts.GUILDS.methods.acceptRequestToAddToGuild,
        rejectRequestToAddToGuild: contracts.GUILDS.methods.requestRequestToAddToGuild,
    },
    GUILD_SAMPLES: {
        newSamplesWithMetadata: contracts.GUILD_SAMPLES.methods.newSamplesWithMetadata,
        newSampleWithMetadata: contracts.GUILD_SAMPLES.methods.newSampleWithMetadata,
        newEncryptedSamples: contracts.GUILD_SAMPLES.methods.newEncryptedSamples,
    },
    ENCRYPTION: {
        setPublicKey: contracts.ENCRYPTION.methods.setPublicKey,
        newEncryptedContent: contracts.ENCRYPTION.methods.newEncryptedContent,
        shareEncryptedContentWith: contracts.ENCRYPTION.methods.newEncryptedContent,
    },
    FOLDERS: {
        foldersUpdated: contracts.FOLDERS.methods.foldersUpdated,
    },
    MESSAGING: {
        sendPublicMessage: contracts.MESSAGING.methods.sendPublicMessage,
    },
    SEQUENCE_METADATA: {
        tagSequence: contracts.SEQUENCE_METADATA.methods.tagSequence,
        starSequence: contracts.SEQUENCE_METADATA.methods.starSequence,
        favoriteSequence: contracts.SEQUENCE_METADATA.methods.favoriteSequence,
        unfavoriteSequence: contracts.SEQUENCE_METADATA.methods.unfavoriteSequence,
        unstarSequence: contracts.SEQUENCE_METADATA.methods.unstarSequence,
    },
    RESAMPLE: {
        newResample: contracts.RESAMPLE.methods.newResample,
    },
    XANADU: {
        newDataType: contracts.XANADU.methods.newDataType,
        newLinkType: contracts.XANADU.methods.newLinkType,
        newAnnotationType: contracts.XANADU.methods.newAnnotationType,
        newLink: contracts.XANADU.methods.newLink,
        newLinks: contracts.XANADU.methods.newLinks,
        newAnnotation: contracts.XANADU.methods.newAnnotation,
    },
    MIX: {
        newMix: contracts.MIX.methods.newMix
    },
    EFFECTS: {
        newEffect: contracts.EFFECTS.methods.newEffect
    },
    FAVORITES:  {
        favoriteSample: contracts.FAVORITES.methods.favoriteSample,
        unfavoriteSample: contracts.FAVORITES.methods.unfavoriteSample
    },
    ARTISTS: {
        newRelease: contracts.ARTISTS.methods.newRelease,
        newArtistInfo: contracts.ARTISTS.methods.newArtistInfo,
        newSampleByArtist: contracts.ARTISTS.methods.newSampleByArtist
    },
    GUILD_SETTINGS: {
        leaveGuild: contracts.GUILD_SETTINGS.methods.guildSettings,
        userChoseDefaultGuild: contracts.GUILD_SETTINGS.methods.userChoseDefaultGuild,
        createGuildWithPeople: contracts.GUILD_SETTINGS.methods.createGuildWithPeople
    },
    MIDI_CC: {
        newMidiCCParameter: contracts.MIDI_CC.methods.newMidiCCParameter
    },
    EXPLORE_LISTS: {
        editList: contracts.EXPLORE_LISTS.methods.editList,
        bulkEdit: contracts.EXPLORE_LISTS.methods.bulkEdit,
        deleteList: contracts.EXPLORE_LISTS.methods.deleteList,
        highlightList: contracts.EXPLORE_LISTS.methods.highlightList,
        unhighlightList: contracts.EXPLORE_LISTS.methods.unhighlightList,
        favoriteList: contracts.EXPLORE_LISTS.methods.favoriteList,
        unfavoriteList: contracts.EXPLORE_LISTS.methods.unfavoriteList
    },
    WALLPAPER: {
        newWallpaper: contracts.WALLPAPER.methods.newWallpaper,
        setDefaultWallpaper: contracts.WALLPAPER.methods.setDefaultWallpaper,
    },
    PACKS: {
        newPack: contracts.PACKS.methods.newPack,
    },
    SCRIPTS: {
        newScript: contracts.SCRIPTS.methods.newScript,
    }
};

export default contractMethods;
